import { Component, OnInit} from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { NgProgress } from '@ngx-progressbar/core';
import { IdleTimeoutService } from './shared/idle-timeout-service.service';
import { PosthogService } from './shared/posthog.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  constructor(private progress: NgProgress, private router: Router, private idleService: IdleTimeoutService, private posthog: PosthogService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.ngProgress.start();
      } else if (event instanceof NavigationEnd) {
        this.ngProgress.complete();
        this.posthog.pageview(event.urlAfterRedirects);
      } else if (
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.ngProgress.complete();
      }
    });
  }
  ngProgress
  ngOnInit(): void {
    this.ngProgress = this.progress.ref()
    this.idleService.startWatching(this);
  }


  ngOnDestroy(): void {
    this.idleService.stopWatching(); // Cleanup when component is destroyed
  }

  toggleErrorModal(action: string): void {
    this.errorModal = action === 'open';
  }
errorModal:boolean
dismissModal(): void {
  this.errorModal = false;
  this.router.navigate(['/auth/login']); // Redirect to login
}

}
